import { Color, Spacing } from '@persona-id/design-tokens';
import { XIcon } from '@persona-id/design-tokens/icons';
import { MEDIA_WIDTHS, mediaQuery } from 'shared/styles/variables';
import styled from 'styled-components';

import Button from 'design-system/components/Button';
import Card from 'design-system/components/Card';
import Spacer from 'design-system/components/Spacer';
import { Paragraph } from 'design-system/components/Text';
import SimulateImage from 'images/dashboard/simulate.svg';
import { LocalStorageKey } from 'lib/clients/StorageClient';
import useLocalStorage from 'lib/hooks/useLocalStorage';

const InquirySimulateBanner = () => {
  const [isBannerDismissed, setIsBannerDismissed] = useLocalStorage(
    LocalStorageKey.DashboardInquirySimulateBannerDismissed,
    false,
  );

  return !isBannerDismissed ? (
    <BannerCard>
      <Card.Body>
        <Card.Title
          actions={
            <Button variant='basic' size='sm' width='icon'>
              <XIcon onClick={() => setIsBannerDismissed(true)} />
            </Button>
          }
        >
          Simulating Inquiry results in Sandbox
        </Card.Title>
        <BannerCardRow>
          <div>
            <Paragraph color='primary'>
              To test your configurations or understand why an Inquiry may reach a certain end
              status, you can use <b>Simulate</b> to mimic different user inputs and create a sample
              Inquiry in your Sandbox environment.
            </Paragraph>
            <Spacer height={2} />
            <Paragraph color='primary'>
              Simulate allows you to QA verification check configurations, mock what happens when
              users input specific values, and ensure that your Inquiry flow works as intended.
            </Paragraph>
            <Spacer height={3} />
            <Button
              variant='primary'
              size='md'
              width='button'
              to='https://help.withpersona.com/articles/5NB4eGgy0k8oRs5O5sDOR1/?utm_source=product&utm_medium=referral&utm_audience=a&utm_campaign=cm_gen_ds_inquiries-simulate'
            >
              Learn more
            </Button>
          </div>
          <BannerCardImage>
            <SimulateImage />
          </BannerCardImage>
        </BannerCardRow>
      </Card.Body>
    </BannerCard>
  ) : null;
};

const BannerCard = styled(Card)`
  background-color: ${Color.CorePurple100};
`;

const BannerCardRow = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: ${Spacing[4]};
`;

const BannerCardImage = styled.div`
  margin-top: -50px;

  @media ${mediaQuery({ max: MEDIA_WIDTHS.desktop })} {
    svg {
      display: none;
    }
  }
`;

export default InquirySimulateBanner;
